module.exports = __webpack_public_path__ + "h5/img/next.454efae5.png";